import { SearchSource } from '@carvana/merch-contracts';
import { Suggestion as TSuggestion } from './contracts';

export const GET_SUGGESTIONS_V4 = '/merch/search/api/v4/suggest';
export const GET_DEALERSHIP_SUGGESTIONS_V4 =
  '/merch/search/api/v4/suggest/dealership';

export const placeHolderText = 'Search make, model, or keyword';
// Intentionally a separate constant from `placeHolderText`: the accessible name
// must remain meaningful even if the visible placeholder copy is later changed.
export const searchInputAccessibleName = 'Search make, model, or keyword';
// The mobile "fake button" is a readonly input that opens the search modal — not the
// search field itself. It gets an action-oriented name so it does not collide with the
// real input's accessible name when the modal is open (two same-named textboxes).
export const searchModalButtonAccessibleName = 'Open search';
export const shortPlaceHolderText = 'Make, model, or keyword';
export const openTextSearchSuffix = ' – Search';

export const SearchBarEventName = 'Search Bar';

export enum EventAction {
  Clicked = 'clicked',
  Enter = 'enter',
  Focused = 'focused',
  Viewed = 'viewed'
}

export enum EventDescription {
  CancelButton = 'Cancel button',
  GoButton = 'Go button',
  NoResults = 'No results',
  RemoveAllRecent = 'Removed all recent',
  RemoveSingleRecent = 'Removed single recent',
  Suggestion = 'Suggestion',
  TypedText = 'Typed Text',
  ViewSavedSearches = 'View all saved searches'
}

export const noSelectedSuggestion: TSuggestion = {
  href: '/cars',
  text: '',
  searchType: SearchSource.InitialPageLoad,
  textSegments: []
};
